// ligfrontend/src/components/Lig/FeedNote.jsx
import React from "react";
import "./FeedNote.css";

const FeedNote = ({ noteEx, time, onReveal }) => {
  return (
    <div className="feed-note">
      <div className="feed-note-header">
        {!noteEx.revealName ? (
          <button className="guess-button" onClick={onReveal}>
            <span className="mystery-icon">🎭</span>
            Guess Who?
          </button>
        ) : (
          <div className="revealed-author">
            <span className="author-name">{noteEx.member.name}</span>
            <span className="author-time">{time}</span>
          </div>
        )}
      </div>

      <div className="feed-note-content">
        <div className="quote-mark">❝</div>
        <p className="feed-note-text">{noteEx.note.msg}</p>
        <div className="quote-mark-end">❞</div>
      </div>
    </div>
  );
};

export default FeedNote;
